import React from 'react'
import logo from '../assets/logo1.png'
import About1 from '../assets/aboutimages/About1.jpeg'
import About2 from '../assets/aboutimages/About2.jpeg'
import About3 from '../assets/aboutimages/About3.jpeg'
import LinkToGallery from './LinkToGallery'

function About() {
    return (
        <div className="font-monospace">
            <div className="container-fluid pageHeading py-4">
                <div className="fs-1 text-center">About</div>
            </div>

            <div className="container-fluid darkSection">
                <div className="container text-center py-5 px-3">
                    <div className="row">
                        <div className="col-12 col-lg-8 align-self-center py-3 px-3 px-lg-5">
                            <div className="fs-2 pb-3">Why this website?</div>
                            <div>
                                This is where it all comes together. All of my artworks on display- illustrations or sketches
                                , original or inspired from someplace. Now why a website if I have an instagram page for the same?
                                Well, its all very random over there [hence the name -
                                <a href="https://www.instagram.com/random_arts_by_j/" target="_blank" className="mylink text-light">random_arts_by_j</a>].
                                But here, it's organized section wise and looks much more presentable. So yeah, that's about it.
                            </div>
                        </div>
                        <div className="col-12 col-lg-4 py-3 align-self-center">
                            <img src={About1} alt="A Cool Image" className="rounded-circle img-fluid w-75" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid lightSection">
                <div className="container text-center py-5 px-3">
                    <div className="row">
                        <div className="col-12 col-lg-4 align-self-center py-3 order-last order-lg-first">
                            <img src={About2} alt="A Cool Image" className="rounded-circle img-fluid w-75" />
                        </div>
                        <div className="col-12 col-lg-8 align-self-center py-3 px-3 px-lg-5">
                            <div className="fs-2 pb-3">Why 'Journey through my journal' ?</div>
                            <div>
                                People have a lot of ideas and opinions on a daily basis. Those who wish to keep a track
                                of all these thoughts maintain a journal. I do so too but instead of writing stuff 
                                down, I put it on paper in the form of a drawing. So in a way, all these illustrations
                                 are a result of some or the other thought I had which was interesting enough to be noted down.
                                And if you think about it, viewing all of these art pieces is sort of going on a `journey through 
                                my journal`.<br />
                                [Either that or I couldn't come up with a better name and hence the description :)]
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid darkSection">
                <div className="container text-center py-5 px-3">
                    <div className="row">
                        <div className="col-12 col-lg-8 align-self-center py-3 px-3 px-lg-5">
                            <div className="fs-2 pb-3">What do I make?</div>
                            <div>
                                A bit of everything I suppose. I do make digital illustrations a lot but it's 
                                not limited to that. I love making pieces in black ink - mandalas, patterns, sketches; and 
                                I have given portraits a try too [they don't turn out to be perfect but they are alright]. 
                                Each piece takes up a lot of hours [sometimes days] but I enjoy the process so much and they 
                                turn out well so it's worth it. :) 
                            </div>
                        </div>
                        <div className="col-12 col-lg-4 py-3 align-self-center">
                            <img src={About3} alt="A Cool Image" className="rounded-circle img-fluid w-75" />
                        </div>
                    </div>
                </div>
            </div>

            <LinkToGallery />

        </div>
    )
}

export default About;
